export default "__VITE_ASSET__fffca6d7__"